// src/components/Footer.js
import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        background: isDark
          ? 'linear-gradient(180deg, rgba(7,17,31,0) 0%, rgba(7,17,31,0.92) 30%, rgba(7,17,31,1) 100%)'
          : 'linear-gradient(180deg, rgba(238,244,250,0) 0%, rgba(238,244,250,0.92) 30%, rgba(238,244,250,1) 100%)',
        color: 'text.primary',
        py: 4,
        mt: 'auto',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container
        sx={{
          maxWidth: '1280px',
          mx: 'auto',
          px: 2,
          textAlign: 'left',
        }}
      >
        <Stack spacing={1}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {t('common.appName')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 640 }}>
            {t('footer.summary')}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary', pt: 1 }}>
            {t('footer.disclaimer')}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
